'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index$2 = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index = require('../../../../../../node_modules/@radix-ui/react-dialog/dist/index.cjs');
var index$1 = require('../../../../../../node_modules/@radix-ui/react-visually-hidden/dist/index.cjs');
var React = require('react');
var Button_web = require('../../atoms/Button/Button.web.cjs');
var Content_web = require('./Content/Content.web.cjs');
var Footer_web = require('./Footer/Footer.web.cjs');
var Header_web = require('./Header/Header.web.cjs');
var Modal_web_styles = require('./Modal.web.styles.cjs');

/**
 * A component that opens over the main content and requires the user to interact with it before returning to the page.
 *
 * {@link https://aviary.fullscript.io/latest/components/modal/web-dkYHLUdc-dkYHLUdc | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/Modal/Modal.web.tsx | View in GitLab}
 *
 * @scope Core
 * @compound Modal.Header - Modal header
 * @compound Modal.Content - Modal content
 * @compound Modal.Footer - Modal footer
 *
 * @example
 * ```tsx
 * <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
 *   <Modal.Header title="Edit Address" subtitle="Update your address" />
 *   <Modal.Content>
 *     <p>Modal content...</p>
 *   </Modal.Content>
 *   <Modal.Footer>
 *     <Button>Save</Button>
 *     <Button>Cancel</Button>
 *   </Modal.Footer>
 * </Modal>
 * ```
 */ const Modal = ({ children, isOpen, onOpenChange, title, ...rest })=>{
    // Check if Modal.Header is present in children
    const hasHeader = React.Children.toArray(children).some((child)=>/*#__PURE__*/ React.isValidElement(child) && child.type === Header_web.Header);
    return /*#__PURE__*/ jsxRuntime.jsx(index.Root, {
        open: isOpen,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ jsxRuntime.jsxs(index.Portal, {
            children: [
                /*#__PURE__*/ jsxRuntime.jsx(index.Overlay, {
                    css: Modal_web_styles.overlay,
                    className: "ModalOverlay"
                }),
                /*#__PURE__*/ jsxRuntime.jsxs(index.Content, {
                    css: Modal_web_styles.content,
                    "aria-describedby": undefined,
                    ...rest,
                    children: [
                        !hasHeader && /*#__PURE__*/ jsxRuntime.jsx(index$1.VisuallyHidden, {
                            children: /*#__PURE__*/ jsxRuntime.jsx(index.Title, {
                                children: title || "Modal"
                            })
                        }),
                        /*#__PURE__*/ jsxRuntime.jsx(index.Close, {
                            asChild: true,
                            children: /*#__PURE__*/ jsxRuntime.jsx(Button_web.Button, {
                                rightIcon: index$2.faXmark,
                                size: "small",
                                "aria-label": "Close",
                                variant: "tertiary",
                                customCss: Modal_web_styles.closeButton
                            })
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
Modal.Header = Header_web.Header;
Modal.Content = Content_web.Content;
Modal.Footer = Footer_web.Footer;

exports.Modal = Modal;
//# sourceMappingURL=Modal.web.cjs.map
